export default {
  computed: {
    /**
     * 页数统一计算，如果无数据，则总页数计为1
     *
     * @returns
     */
    pageCount() {
      const { sumCount, pageSize } = this;
      return Math.ceil(sumCount / pageSize) === 0 ? 1 : Math.ceil(sumCount / pageSize);
    },
  },
};
